export default "__VITE_ASSET__CrJ8i28p__"